import { FC } from 'react';
import { SvgIconProps } from '@mui/material';
import colors from '@styles/colors.module.scss';
import { Icon } from '@components/Icon';

export const SwitchViewIcon: FC<SvgIconProps> = (props) => {
  return <Icon {...props} name="chevronUp" htmlColor={colors.black} />;
};
